<template>
  <div
    id="tao-don-vi"
    size="xl"
    centered
    :title="laSuaDonVi ? 'Sửa thông tin đơn vị' : 'Thêm mới đơn vị'"
    ref="my-modal"
  >
    <div>
      <div class="d-flex justify-content-end mb-2">
        <div class="btn-tab-position-area">
          <base-button class="btn btn-green" @click="onSubmit" button="Lưu" />
          <base-button
            class="btn btn-yellow ml-2"
            @click="refreshForm"
            button="Làm mới"
          />
          <base-button
            class="btn btn-yellow ml-2"
            @click="dongModal"
            button="Đóng"
          />
        </div>
      </div>
      <validation-observer ref="obCanBo">
        <b-form>
          <b-row>
            <b-col sm="6">
              <ValidationProvider
                name="Tên đơn vị"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group
                  label="Tên đơn vị"
                  label-class="required font-weight-bold"
                  label-for="hoTen"
                >
                  <b-form-input
                    :disabled="onlyView"
                    :state="getValidationState(validationContext)"
                    id="hoTen"
                    v-model="form.tenDonVi"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col sm="6">
              <ValidationProvider
                name="Mã đơn vị"
                rules="code|hashcode"
                v-slot="validationContext"
              >
                <b-form-group
                  label="Mã đơn vị"
                  label-class="font-weight-bold"
                  label-for="maDonVi"
                >
                  <b-form-input
                    :disabled="onlyView"
                    :state="getValidationState(validationContext)"
                    id="maDonVi"
                    v-model="form.maDonVi"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Đơn vị cha"
                label-class="font-weight-bold"
                label-for="donVi"
              >
                <treeselect
                  noOptionsText="Không có dữ liệu"
                  noResultsText="Không có kết quả"
                  noChildrenText="Không có kết quả"
                  v-model="form.iD_DonVi_Cha"
                  :options="danhSachDonViBanDau || []"
                  placeholder="Chọn đơn vị"
                  @input="isErrorDonViCha"
                >
                  <label
                    :class="labelClassName"
                    slot="option-label"
                    slot-scope="{
                      node,
                      shouldShowCount,
                      count,
                      labelClassName,
                      countClassName,
                    }"
                  >
                    {{ node.label }}
                    <span
                      :class="countClassName"
                      v-if="shouldShowCount && count > 0"
                      >({{ count }})</span
                    >
                  </label>
                </treeselect>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Mã liên thông"
                label-class="font-weight-bold"
                label-for="maLienThong"
              >
                <b-form-input
                  :disabled="onlyView"
                  id="maLienThong"
                  v-model="form.maLienThong"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Mã liên thông mới"
                label-class="font-weight-bold"
                label-for="maLienThong"
              >
                <b-form-input
                  :disabled="onlyView"
                  id="maLienThong"
                  v-model="form.maLienThongMoi"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Mã đơn vị ghép"
                label-class="font-weight-bold"
                label-for="maLienThong"
              >
                <b-form-input
                  :disabled="onlyView"
                  id="maLienThong"
                  v-model="form.maDonViGhep"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Thứ tự"
                label-class="font-weight-bold"
                label-for="thuTu"
              >
                <b-form-input
                  :disabled="onlyView"
                  id="thuTu"
                  v-model="form.thuTu"
                  type="number"
                ></b-form-input>
              </b-form-group> </b-col
            ><b-col sm="6">
              <ValidationProvider
                name="Số điện thoại"
                rules="phone_number:8,20"
                v-slot="validationContext"
              >
                <b-form-group
                  label="Số điện thoại"
                  label-class="font-weight-bold"
                  label-for="soDienThoai"
                >
                  <b-form-input
                    :disabled="onlyView"
                    :state="getValidationState(validationContext)"
                    id="soDienThoai"
                    v-model="form.soDienThoai"
                    type="text"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider> </b-col
            ><b-col sm="6">
              <ValidationProvider
                name="Email"
                rules="email"
                v-slot="validationContext"
              >
                <b-form-group
                  label="Email"
                  label-class="font-weight-bold"
                  label-for="email"
                >
                  <b-form-input
                    :disabled="onlyView"
                    :state="getValidationState(validationContext)"
                    id="email"
                    v-model="form.email"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider> </b-col
            ><b-col sm="6">
              <ValidationProvider
                name="Fax"
                rules="fax:8,20"
                v-slot="validationContext"
              >
                <b-form-group
                  label="Fax"
                  label-class="font-weight-bold"
                  label-for="fax"
                >
                  <b-form-input
                    type="text"
                    :state="getValidationState(validationContext)"
                    :disabled="onlyView"
                    id="fax"
                    v-model="form.fax"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col sm="6">
              <ValidationProvider
                name="Loại đơn vị"
                rules="required:select"
                v-slot="validationContext"
              >
                <b-form-group
                  label="Loại đơn vị"
                  label-class="font-weight-bold"
                  label-for="loai đơn vị"
                >
                  <v-select
                    :class="
                      selectClass(
                        validationContext.invalid && validationContext.validated
                      )
                    "
                    :options="luaChonDonViPhongBan"
                    label="text"
                    :reduce="(app) => app.id"
                    v-model="form.bit_KieuDonVi"
                    placeholder="Chọn loại đơn vị"
                    :clearable="false"
                  ></v-select>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col sm="6">
              <ValidationProvider
                name="Trạng thái hoạt động"
                rules="required:select"
                v-slot="validationContext"
              >
                <b-form-group
                  label="Trạng thái"
                  label-class="font-weight-bold"
                  label-for="loai đơn vị"
                >
                  <v-select
                    :class="
                      selectClass(
                        validationContext.invalid && validationContext.validated
                      )
                    "
                    :options="MANG_TRANG_THAI_HOAT_DONG"
                    :reduce="(app) => app.key"
                    label="label"
                    v-model="form.bit_TrangThaiDonVi"
                    placeholder="Trạng thái hoạt động"
                    :clearable="false"
                  ></v-select>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col sm="6">
              <ValidationProvider
                name="Loại đơn vị xử lý"
                v-slot="validationContext"
              >
                <b-form-group
                  label="Loại đơn vị xử lý"
                  label-class="font-weight-bold"
                  label-for="loai đơn vị xử lý"
                >
                  <v-select
                    :class="
                      selectClass(
                        validationContext.invalid && validationContext.validated
                      )
                    "
                    :options="luaChonLoaiDonViXuLy"
                    label="text"
                    :reduce="(app) => app.id"
                    v-model="form.loaiDonViXuLy"
                    placeholder="Chọn loại đơn vị xử lý"
                    :clearable="false"
                  ></v-select>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
             <b-col sm="6">
              <b-form-group
              label="Đơn vị có dấu"
                label-class="font-weight-bold"
                label-for="Đơn vị có dấu"
              >
                <b-form-checkbox
                  v-model="form.bit_DonViCoDau"
                  :value="1"
                  :unchecked-value="0"
                >
                  Đơn vị có dấu
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label-class="font-weight-bold"
                label-for="loai đơn vị"
              >
                <b-form-checkbox
                  v-model="form.isDiaChiDonViCha"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="disabledDiaChiDonViCha"
                >
                  Theo địa chỉ của đơn vị cha
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                label-class="font-weight-bold"
                label-for="loại đơn vị"
              >
                <b-form-checkbox
                  v-model="form.isVirtualDepartment"
                  :value="true"
                  :unchecked-value="false"
                >
                  Là đơn vị ảo
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col sm="3" v-if="!form.iD_DonVi_Cha">
              <b-form-group
                label-class="font-weight-bold"
                label-for="loại đơn vị"
              >
                <b-form-checkbox
                  v-model="form.isExternalDepartment"
                  :value="true"
                  :unchecked-value="false"
                >
                  Là đơn vị ngoài
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col cols="12" class="row m-0 p-0" v-if="!form.isDiaChiDonViCha">
              <b-col cols="6">
                <ValidationProvider
                  name="Tỉnh/TP"
                  rules="required:select"
                  v-slot="validationContext"
                >
                  <b-form-group
                    label="Tỉnh/TP"
                    label-class="required font-weight-bold"
                    label-for="tinhTP"
                  >
                    <v-select
                      id="tinhTP"
                      :class="
                        selectClass(
                          validationContext.invalid &&
                            validationContext.validated
                        )
                      "
                      v-model="form.tinhThanh"
                      :options="listTinhThanh"
                      :reduce="(opt) => opt.id"
                      label="name"
                      @change="loadHuyen"
                    ></v-select>
                    <b-form-invalid-feedback
                      >{{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col cols="6">
                <ValidationProvider
                  name="Quận/huyện"
                  rules="required:select"
                  v-slot="validationContext"
                >
                  <b-form-group
                    label="Quận/huyện"
                    label-class="required font-weight-bold"
                    label-for="quanHuyen"
                  >
                    <v-select
                      :class="
                        selectClass(
                          validationContext.invalid &&
                            validationContext.validated
                        )
                      "
                      id="quanHuyen"
                      :key="showHuyen"
                      v-model="form.quanHuyen"
                      :options="listQuanHuyen"
                      :reduce="(opt) => opt.id"
                      label="name"
                      @change="loadXa"
                      :disabled="!form.tinhThanh"
                    ></v-select>
                    <b-form-invalid-feedback
                      >{{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col cols="6">
                <ValidationProvider
                  name="Phường/xã"
                  rules="required:select"
                  v-slot="validationContext"
                >
                  <b-form-group
                    label="Phường/xã"
                    label-class="required font-weight-bold"
                    label-for="phuongXa"
                  >
                    <v-select
                      :class="
                        selectClass(
                          validationContext.invalid &&
                            validationContext.validated
                        )
                      "
                      id="phuongXa"
                      :key="showXa"
                      v-model="form.phuongXa"
                      :options="listPhuongXa"
                      :reduce="(opt) => opt.id"
                      label="name"
                      :disabled="!form.quanHuyen"
                    ></v-select>
                    <b-form-invalid-feedback
                      >{{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col cols="6">
                <ValidationProvider
                  name="Cấp đơn vị"
                  rules="requiredMultiple"
                  v-slot="validationContext"
                >
                  <b-form-group
                    label="Cấp đơn vị"
                    label-class="required font-weight-bold"
                    label-for="phuongXa"
                  >
                    <treeselect
                      noOptionsText="Không có dữ liệu"
                      noResultsText="Không có kết quả"
                      noChildrenText="Không có kết quả"
                      v-model="form.capDonViIds"
                      :options="danhSachCapDonViNoiBo || []"
                      placeholder="Chọn cấp đơn vị"
                      :multiple="true"
                      :flat="true"
                      :state="getValidationState(validationContext)"
                      :class="
                        selectClass(
                          validationContext.invalid &&
                            validationContext.validated
                        )
                      "
                    >
                      <label
                        :class="labelClassName"
                        slot="option-label"
                        slot-scope="{
                          node,
                          shouldShowCount,
                          count,
                          labelClassName,
                          countClassName,
                        }"
                      >
                        {{ node.label }}
                        <span
                          :class="countClassName"
                          v-if="shouldShowCount && count > 0"
                          >({{ count }})</span
                        >
                      </label>
                    </treeselect>

                    <b-form-invalid-feedback
                      >{{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col sm="12">
                <b-form-group
                  label="Địa chỉ"
                  label-class="font-weight-bold"
                  label-for="maLienThong"
                >
                  <b-form-input
                    id="maLienThong"
                    v-model="form.diaChi"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label-class="font-weight-bold"
              >
                <b-form-checkbox
                  v-model="form.bit_DonViMoi"
                  :value="true"
                  :unchecked-value="false"
                >
                  Là đơn vị mới
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label-class="font-weight-bold"
              >
                <b-form-checkbox
                  v-model="form.bit_SuDungHeThong"
                  :value="true"
                  :unchecked-value="false"
                >
                  Sử dụng hệ thống Quản lý văn bản
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import {
  HUY_BO_BUTTON_LABEL,
  ROUTE_NAME,
  MANG_TRANG_THAI_HOAT_DONG,
} from "@/constants/constants";
import { Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
const defaultForm = {
  tenDonVi: "",
  iD_DonVi_Cha: null,
  iD_DonVi_Goc: null,
  maDonVi: "",
  capDonVi: 0,
  capDonViIds: [],
  duongDan_ID_DonVi_Cha: "",
  duongDan_ID_DonVi: "",
  maLienThong: "",
  maLienThongMoi: "",
  maDonViGhep: "",
  thuTu: null,
  bit_KieuDonVi: 1,
  bit_TrangThaiDonVi: 1,
  soDienThoai: "",
  email: "",
  fax: "",
  isDiaChiDonViCha: false,
  isVirtualDepartment: false,
  isExternalDepartment: false,
  diaChi: "",
  tinhThanh: null,
  quanHuyen: null,
  phuongXa: null,
  loaiDonViXuLy: null,
  bit_DonViCoDau: null
};
export default {
  name: "FormDonVi",
  components: {
    Treeselect,
  },
  data() {
    return {
      value: null,
      guidEmpty: "00000000-0000-0000-0000-000000000000",
      ROUTE: ROUTE_NAME,
      HUY_BO_BUTTON_LABEL: HUY_BO_BUTTON_LABEL,
      MANG_TRANG_THAI_HOAT_DONG,
      activeTab: 1,
      items: [],
      donViDaChon: null,
      showHuyen: true,
      showXa: true,
      listTinhThanh: [],
      listQuanHuyen: [],
      listPhuongXa: [],
      reloadDonVI: false,
      form: _cloneDeep(defaultForm),
      idDonViCha: this.$route.query.idDonViCha,
      onlyView: this.$route.query.onlyview,
      luaChonDonViPhongBan: [
        {
          text: "Đơn vị",
          id: 1,
        },
        {
          text: "Phòng ban",
          id: 2,
        },
      ],
      luaChonLoaiDonViXuLy:[{
          text: "Vụ, cục, tương đương (thuộc bộ)",
          id: 0,
        },{
          text: "Vụ, cục (thuộc tổng cục)",
          id: 1,
        },
        {
          text: "Cục thống kê tỉnh",
          id: 2,
        },
        {
          text: "Tổng cục thống kê",
          id: 3,
        },
        {
          text: "Bộ",
          id: 4,
        },
      ],
      disabledDiaChiDonViCha: false,
    };
  },
  props: {
    chiTietDonVi: {
      type: Object,
      required: true,
    },
    laSuaDonVi: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      chiTietCanBo: "canBo/canBo",
      danhSachDonVi: "donVi/danhSachDonVi",
      danhSachCapDonVi: "capDonVi/danhSachCapDonVi",
    }),
    danhSachCapDonViNoiBo() {
      if (!this.danhSachCapDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachCapDonVi.map((item) => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.parentId,
          Label: item.tenCapDonVi,
          Childrens: [],
          ...item,
        };
      });
      return this.list_to_tree(danhSach);
    },
    danhSachDonViBanDau() {
      if (!this.danhSachDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachDonVi.map((item) => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.iD_DonVi_Cha,
          Label: item.tenDonVi,
          Childrens: [],
          ...item,
        };
      });
      return this.list_to_tree(danhSach);
    },
  },
  created() {
    this.layDiaChi();
    this.layDanhSachCapDonVi();
  },
  methods: {
    layDanhSachCapDonVi() {
      this.$store.dispatch("capDonVi/layDanhSachCapDonVi");
    },
    async loadDiaChi() {
      if (!this.form.tinhThanh) {
        this.form.quanHuyen = null;
      } else {
        await this.layDiaChi(this.form.tinhThanh, "listQuanHuyen");
        this.form.quanHuyen = this.listQuanHuyen[0].id;
      }
      if (!this.form.quanHuyen) {
        this.form.phuongXa = null;
      } else {
        await this.layDiaChi(this.form.quanHuyen, "listPhuongXa");
        this.form.phuongXa = this.listPhuongXa[0].id;
      }
    },
    async layDiaChi(parantId = null, field = "listTinhThanh") {
      await this.$store.dispatch("common/layTinhThanh", {
        data: {
          parentId: parantId,
          level: parantId == null ? 1 : null,
        },
        onSuccess: (data) => {
          this[field] = data;
        },
      });
    },
    async loadXa() {
      if (!this.form.quanHuyen) {
        this.form.phuongXa = null;
      } else {
        this.showXa = false;
        await this.layDiaChi(this.form.quanHuyen, "listPhuongXa");
        this.form.phuongXa = this.listPhuongXa[0].id;
        this.showXa = true;
      }
    },
    async loadHuyen() {
      if (!this.form.tinhThanh) {
        this.form.phuongXa = null;
        this.loadXa();
      } else {
        this.showXa = false;
        await this.layDiaChi(this.form.tinhThanh, "listPhuongXa");
        this.form.phuongXa = this.listPhuongXa[0].id;
        this.showXa = true;
        this.loadXa();
      }
    },
    selectClass(valid) {
      return {
        "is-invalid select-invalid treeselect-invalid": valid,
      };
    },
    refreshForm() {
      if (this.laSuaDonVi) {
        this.form = Object.assign({}, this.form, this.chiTietDonVi);
        this.form.tinhThanh = this.chiTietDonVi.tinhId;
        this.form.quanHuyen = this.chiTietDonVi.huyenId;
        this.form.phuongXa = this.chiTietDonVi.xaId;
      } else {
        this.form = _cloneDeep(defaultForm);
        this.form.iD_DonVi_Cha = this.chiTietDonVi.id;
        this.layThuTuMacDinh();
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    list_to_tree(list) {
      if (list.length > 0) {
        var map = {},
          node,
          roots = [],
          i;
        for (i = 0; i < list.length; i += 1) {
          map[list[i].Task_ID] = i; // initialize the map
          list[i].Childrens = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          if (node.Task_Parent_ID !== this.guidEmpty) {
            // if you have dangling branches check that map[node.parentId] exists
            if (list[map[node.Task_Parent_ID]] != null) {
              list[map[node.Task_Parent_ID]].Childrens.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            } else {
              roots.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            }
          } else {
            roots.push({
              id: node.Task_ID,
              label: node.Label,
              parentId: node.Task_Parent_ID,
              children: node.Childrens,
            });
          }
        }
        return roots;
      }
      return list;
    },
    changeCurrentTab(tab) {
      this.activeTab = tab;
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.tenDonVi,
        children: node.children || null,
      };
    },
    dongModal() {
      this.$emit("closeForm");
    },
    async onSubmit() {
      if (this.laSuaDonVi) {
        await this.suaDonVi();
      } else {
        await this.themMoiDonVi();
      }
    },
    async themMoiDonVi() {
      const isValid = await this.$refs.obCanBo.validate();
      if (!isValid) {
        return;
      }
      const $vm = this;
      let data = $vm.form;
      let payload = {
        tenDonVi: data.tenDonVi,
        iD_DonVi_Cha: data.iD_DonVi_Cha || null,
        maDonVi: data.maDonVi,
        maLienThong: data.maLienThong,
        maLienThongMoi: data.maLienThongMoi,
        maDonViGhep: data.maDonViGhep,
        thuTu: data.thuTu,
        soDienThoai: data.soDienThoai,
        email: data.email,
        fax: data.fax,
        bit_KieuDonVi: data.bit_KieuDonVi,
        bit_TrangThaiDonVi: data.bit_TrangThaiDonVi,
        isVirtualDepartment: data.isVirtualDepartment,
        isExternalDepartment: data.isExternalDepartment,
        isDiaChiDonViCha: data.isDiaChiDonViCha,
        tinhId: data.tinhThanh,
        huyenId: data.quanHuyen,
        xaId: data.phuongXa,
        capDonViIds: data.capDonViIds,
        diaChi: data.diaChi,
        bit_DonViMoi: data.bit_DonViMoi,
        bit_SuDungHeThong: data.bit_SuDungHeThong,
      };
      this.$store.dispatch("donVi/taoMoiDonVi", payload).then((res) => {
        if (res.data.succeeded) {
          this.$toasted.clear();
          $vm.$toasted.global.showSuccessMessage({
            message: "Lưu thành công đơn vị",
          });
          let donVi = {
            ...res.data.data.data,
            Task_ID: res.data.data.data.id,
            Task_Parent_ID: res.data.data.data.iD_DonVi_Cha,
          };
          $vm.$emit("layDanhSachDonVi", donVi);
          $vm.dongModal();
        } else {
          this.$toasted.clear();
          $vm.$toasted.global.showErrorMessage({
            message: res.data.message,
          });
        }
      });
    },

    async suaDonVi() {
      const isValid = await this.$refs.obCanBo.validate();
      if (!isValid) {
        return;
      }
      const isCollideParrent = this.isErrorDonViCha();
      if (isCollideParrent) {
        return;
      }
      const $vm = this;
      let data = $vm.form;
      let payload = {
        ...data,
        id: data.id,
        iD_DonVi_Cha: data.iD_DonVi_Cha || null,
        thuTu: data.thuTu,
        bit_KieuDonVi: data.bit_KieuDonVi,
        isVirtualDepartment: data.isVirtualDepartment,
        isExternalDepartment: data.isExternalDepartment,
        isDiaChiDonViCha: data.isDiaChiDonViCha,
        tinhId: data.tinhThanh,
        huyenId: data.quanHuyen,
        xaId: data.phuongXa,
      };
      this.$store.dispatch("donVi/suaDonVi", payload).then((res) => {
        if (res.data.succeeded) {
          this.$toasted.clear();
          $vm.$toasted.global.showSuccessMessage({
            message: "Cập nhật thông tin đơn vị thành công",
          });
          $vm.dongModal();
          let donVi = {
            ...res.data.data.data,
            Task_ID: res.data.data.data.id,
            Task_Parent_ID: res.data.data.data.iD_DonVi_Cha,
          };
          $vm.$emit("layDanhSachDonVi", donVi);
        } else {
          this.$toasted.clear();
          $vm.$toasted.global.showErrorMessage({
            message: res.data.message,
          });
        }
      });
    },
    layThuTuMacDinh() {
      if (this.form?.iD_DonVi_Cha) {
        this.$store
          .dispatch("donVi/layThuTuMacDinh", {
            idCha: this.form.iD_DonVi_Cha,
          })
          .then((res) => {
            if (res.data.succeeded) {
              this.form.thuTu = res.data.data;
            } else {
              console.log("Thao tác thất bại");
            }
          });
      }
    },
    isErrorDonViCha() {
      if (
        this.form.iD_DonVi_Cha &&
        this.form.id &&
        this.form.iD_DonVi_Cha === this.form.id
      ) {
        this.$toasted.clear();
        this.$toasted.global.showErrorMessage({
          message: "Đơn vị cha không thể là đơn vị hiện tại",
        });
        return true;
      }
      return false;
    },
  },
  watch: {
    chiTietDonVi: {
      async handler(val) {
        if (this.laSuaDonVi) {
          this.form = Object.assign({}, this.form, this.chiTietDonVi);
          if (val.tinhId) {
            await this.layDiaChi();
            this.form.tinhThanh = val.tinhId;
            if (val.xaId) {
              await this.layDiaChi(val.huyenId, "listPhuongXa");
              this.form.phuongXa = val.xaId;
            }
            if (val.huyenId) {
              await this.layDiaChi(val.tinhId, "listQuanHuyen");
              this.form.quanHuyen = val.huyenId;
            }
          } else {
            this.form.tinhThanh = null;
            this.form.phuongXa = null;
            this.form.quanHuyen = null;
          }
        } else {
          this.form = _cloneDeep(defaultForm);
          this.form.iD_DonVi_Cha =
            this.chiTietDonVi.Task_ID || this.chiTietDonVi.id;
          this.layThuTuMacDinh();
        }
      },
      deep: true,
    },
    "form.tinhThanh": async function (val) {
      if (!val) {
        this.form.quanHuyen = null;
      } else {
        this.showHuyen = false;
        await this.layDiaChi(val, "listQuanHuyen");
        this.form.quanHuyen = this.listQuanHuyen[0].id;
        this.showHuyen = true;
      }
    },
    "form.quanHuyen": async function (val) {
      if (!val) {
        this.form.phuongXa = null;
      } else {
        this.showXa = false;
        await this.layDiaChi(val, "listPhuongXa");
        this.form.phuongXa = this.listPhuongXa[0].id;
        this.showXa = true;
      }
    },
    "form.iD_DonVi_Cha": {
      handler() {
        if (
          this.form.iD_DonVi_Cha === undefined ||
          this.form.iD_DonVi_Cha === null
        ) {
          this.form.isDiaChiDonViCha = false;
          this.disabledDiaChiDonViCha = true;
        } else {
          this.disabledDiaChiDonViCha = false;
        }
      },
      deep: true,
    },
  },
};
</script>
